import { render } from "./EditLanguages.vue?vue&type=template&id=9d78bb6e"
import script from "./EditLanguages.vue?vue&type=script&lang=js"
export * from "./EditLanguages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__